module.exports = __webpack_public_path__ + "static/media/RI-D4-11.1-083.dcae6609.webp";